<template>
  <v-progress-linear
    v-if='active'
    top
    indeterminate
    height='2px'
    :absolute='true'
    :background-opacity='0'
    color='primary'
  />
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      active: Boolean
    },
  }
</script>
